// get offer details
export const GET_OFFER_DETAILS = "GET_OFFER_DETAILS";
export const GET_OFFER_DETAILS_SUCCESS = "GET_OFFER_DETAILS_SUCCESS";
export const GET_OFFER_DETAILS_FAILED = "GET_OFFER_DETAILS_FAILED";

//save offer details
export const SAVE_OFFER_DETAILS = "SAVE_OFFER_DETAILS";
export const SAVE_OFFER_DETAILS_SUCCESS = "SAVE_OFFER_DETAILS_SUCCESS";
export const SAVE_OFFER_DETAILS_FAILED = "SAVE_OFFER_DETAILS_FAILED";
//get template data
export const GET_TEMPLATE_DETAILS = "GET_TEMPLATE_DETAILS";
export const GET_TEMPLATE_DETAILS_FAILED = "GET_TEMPLATE_DETAILS_FAILED";
export const GET_TEMPLATE_DETAILS_SUCCESS = "GET_TEMPLATE_DETAILS_SUCCESS";
//revoke offer letter
export const REVOKE_OFFER_LETTER = "REVOKE_OFFER_LETTER";
export const REVOKE_OFFER_LETTER_SUCCESS = "REVOKE_OFFER_LETTER_SUCCESS";
export const REVOKE_OFFER_LETTER_FAILED = "REVOKE_OFFER_LETTER_FAILED";

//offer letter common fail pass for all action
export const OFFER_COMMON_ERROR = "OFFER_COMMON_ERROR";
export const OFFER_COMMON_SUCCESS = "OFFER_COMMON_SUCCESS";

export const SHOW_OFFER_LETTER="SHOW_OFFER_LETTER"
export const SHOW_OFFER_LETTER_SUCCESS="SHOW_OFFER_LETTER_SUCCESS"
export const SHOW_OFFER_LETTER_FAILED="SHOW_OFFER_LETTER_FAILED"
